// src/components/molecules/phone/phone-config/phone-config-modal/phone-config-modal-button.tsx

import CopyModal from 'src/modules/shared/components/molecules/modals/copy-modal/index';
import PhoneConfig from '../phone-config/phone-config';
import { useState } from 'react';
import { IconButton } from '@material-tailwind/react';
import { Cog6ToothIcon } from '@heroicons/react/24/solid';
import { type PhoneConfigActions } from 'hooks/phones/types';

interface PhoneConfigModalButtonProps {
  phoneConfigActions: PhoneConfigActions;
}

const PhoneConfigModalButton: React.FC<PhoneConfigModalButtonProps> = ({
  phoneConfigActions,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton
        onClick={() => setIsOpen(true)}
        variant="text"
        className={`w-8 h-8`}
      >
        <Cog6ToothIcon strokeWidth={2} className="h-6 w-6 text-blue-gray-600" />
      </IconButton>
      <CopyModal
        // TODO: check when implementing i18n
        title="Configuración del teléfono"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <PhoneConfig phoneConfigActions={phoneConfigActions} />
      </CopyModal>
    </>
  );
};

export default PhoneConfigModalButton;
